module.exports = __webpack_public_path__ + "static/Soleo1-c7bd9393e0082e01f0e0d3d470293728.jpg";